import axios from "axios";

export function requestGetSettings() {
    return axios.request({
        method: 'get',
        url: "/settings",
        headers: {
            'content-type': 'application/json'
        }
    });

}